import React, { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface ErrorDialogProps {
  variant: 'paymentError' | 'ageDifferenceError';
  open: boolean;
  onClose: () => void;
}

const ErrorDialog: FC<ErrorDialogProps> = ({ open, onClose, variant }) => {
  const { t, i18n } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      data-cy="bookingW_modal_error_modal"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
        }}
        data-cy="bookingW_modal_error_modal_title"
      >
        {t(`MODAL_DIALOG.${variant}.header`)}
        <IconButton onClick={onClose} data-cy="bookingW_modal_error_modal_X">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            mb: 2,
            color: 'var(--red-primary)',
          }}
        >
          {t(`MODAL_DIALOG.${variant}.important`)}
        </Typography>
        <Typography
          sx={{
            textDecoration: 'underline',
            mb: 2,
          }}
        >
          {t(`MODAL_DIALOG.${variant}.whatYouCanDoHeader`)}:
        </Typography>
        {i18n.exists(`MODAL_DIALOG.${variant}.whatYouCanDo1Header`) && (
          <Typography sx={{ mb: 1 }}>
            <Typography sx={{ fontWeight: 'bold', display: 'inline', mr: 1 }}>
              {t(`MODAL_DIALOG.${variant}.whatYouCanDo1Header`)}:
            </Typography>
            {t(`MODAL_DIALOG.${variant}.whatYouCanDo1Text`)}
          </Typography>
        )}
        {i18n.exists(`MODAL_DIALOG.${variant}.whatYouCanDo2Header`) && (
          <Typography sx={{ mb: 1 }}>
            <Typography sx={{ fontWeight: 'bold', display: 'inline', mr: 1 }}>
              {t(`MODAL_DIALOG.${variant}.whatYouCanDo2Header`)}:
            </Typography>
            {t(`MODAL_DIALOG.${variant}.whatYouCanDo2Text`)}
          </Typography>
        )}
        {i18n.exists(`MODAL_DIALOG.${variant}.whatYouCanDo3Header`) && (
          <Typography sx={{ mb: 1 }}>
            <Typography sx={{ fontWeight: 'bold', display: 'inline', mr: 1 }}>
              {t(`MODAL_DIALOG.${variant}.whatYouCanDo3Header`)}:
            </Typography>
            {t(`MODAL_DIALOG.${variant}.whatYouCanDo3Text`)}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          data-cy="bookingW_modal_error_modal_send_btn"
        >
          {i18n.exists(`MODAL_DIALOG.${variant}.close`)
            ? t(`MODAL_DIALOG.${variant}.close`)
            : t('COMMON.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
